import { render, staticRenderFns } from "./SaleAlertNotification.vue?vue&type=template&id=3c87d238"
import script from "./SaleAlertNotification.vue?vue&type=script&lang=js"
export * from "./SaleAlertNotification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports